const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN;
const isTestMode = clientToken?.startsWith("pk_test_");

export default function PaymentTestModeBanner() {
  // Hide in production to avoid cheapening the product
  if (!isTestMode || import.meta.env.PROD) return null;

  return (
    <div className="w-full bg-score-mid/15 border-b border-score-mid/25 py-1.5 px-4 text-center">
      <p className="text-[11px] font-body text-score-mid">
        Test mode — payments are simulated and will not be charged.
      </p>
    </div>
  );
}
